// eslint-disable-next-line import/no-webpack-loader-syntax
require('expose-loader?TrendingBets!../../../src/app/sportsbook_components/trending_bets');
